import React, { useEffect } from 'react';
import GetParameterURL from '../components/GetParameterURL'
import { useLocation, useHistory } from 'react-router-dom'
const RedirectForMonnet = () => {
    let location = useLocation();
    let history = useHistory();

    useEffect(() => {
        const handleRedirect = () => {
            let url = GetParameterURL("url", history, location);
            if (url) {
                const redirectedUrl = url;
                
                // Try to post message to parent (for iframe)
                if (window.parent !== window) {
                    window.parent.postMessage({ type: 'redirected', url: redirectedUrl }, '*');
                }
                
                // Also redirect the current window
                window.location.href = redirectedUrl;
            }
        };

        // Run immediately if page is already loaded
        if (document.readyState === 'complete') {
            handleRedirect();
        } else {
            // Otherwise wait for load event
            window.addEventListener('load', handleRedirect);
        }

        // Cleanup
        return () => {
            window.removeEventListener('load', handleRedirect);
        };
    }, [history, location])
    return (
        <div>
            <div className="container">
                <h1 style={{ color: 'white' }}> Redirecting....</h1>
            </div>
        </div>
    )
}

export default RedirectForMonnet
